import type * as Types from '../../../schemas/shopify/admin.types';

export type PageAnalyticPageInfoNodeFragment = Pick<Types.Page, 'id' | 'title' | 'handle'>;

export const PageAnalyticPageInfoNodeFragmentDoc = `
    fragment PageAnalyticPageInfoNode on Page {
  id
  title
  handle
}
    `;
